<ng-template #spinnerInline>
  <ab-spinner-inline></ab-spinner-inline>
</ng-template>
<div class="digest-stats">
  <div class="digest-stats__errors-deploys">
    <div
      class="card-with-shadow card-with-shadow--orange card-with-shadow--full-width"
    >
      <div
        class="dash-cta"
        *ngIf="missingErrorData && !featureDisabled && digestStats"
      >
        <h4 class="dash-cta__title">
          <i class="glyphicon glyphicon--valign-baseline glyphicon-bug"></i>
          Errors
        </h4>
        <p>
          This project has not received any errors. Please follow the
          instructions on the Errors Dashboard to ensure we receive the data
          needed for error trends.
        </p>
        <div class="dash-cta__image">
          <div class="ab-bugs">
            <img
              class="ab-bugs__bug-small"
              src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/bug.svg"
            />
            <img
              class="ab-bugs__bug-medium"
              src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/bug.svg"
            />
            <img
              class="ab-bugs__bug-large"
              src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/bug.svg"
            />
          </div>
        </div>
        <p>
          <a class="btn btn--primary" uiSref="project-errors">
            Install Airbrake
          </a>
        </p>
      </div>

      <div class="ab-trend" *ngIf="!missingErrorData">
        <h4 class="ab-trend__title">Errors</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.errors.group_count_trend"
          [neutralTrend]="false"
          [increasePositive]="false"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.errors.group_count.current | numberToHuman }}
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs {{ digestStats.errors.group_count.previous | numberToHuman }}
            during the previous week
          </p>
        </div>
      </div>

      <div class="ab-trend" *ngIf="!missingErrorData">
        <h4 class="ab-trend__title">Occurrences</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.errors.notice_count_trend"
          [neutralTrend]="false"
          [increasePositive]="false"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.errors.notice_count.current | numberToHuman }}
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs {{ digestStats.errors.notice_count.previous | numberToHuman }}
            during the previous week
          </p>
        </div>
      </div>
    </div>

    <div
      class="card-with-shadow card-with-shadow--blue card-with-shadow--full-width"
    >
      <div
        class="dash-cta"
        *ngIf="missingDeployData && !featureDisabled && digestStats"
      >
        <h4 class="dash-cta__title">
          <i class="glyphicon glyphicon--valign-baseline glyphicon-flash"></i>
          Deploys
        </h4>
        <p>
          This project has not received any deploys. Please follow the
          instructions on the Deploys Dashboard to ensure we receive the data
          needed for deploy trends.
        </p>
        <div class="dash-cta__image">
          <img
            src="{{ appEnv.cdnUrl }}/{{
              appEnv.assetsPath
            }}/images/deploys-list.svg"
            alt=""
          />
        </div>
        <p>
          <a class="btn btn--secondary" uiSref="project-deploys">
            Set up Deploy tracking
          </a>
        </p>
      </div>

      <div class="ab-trend" *ngIf="!missingDeployData">
        <h4 class="ab-trend__title">Deploys</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.deploys.deploy_count_trend"
          [neutralTrend]="true"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.deploys.deploy_count.current | numberToHuman }}
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs {{ digestStats.deploys.deploy_count.previous | numberToHuman }}
            during the previous week
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="digest-stats__apm">
    <div
      class="card-with-shadow card-with-shadow--green card-with-shadow--full-width"
    >
      <div
        class="dash-cta"
        *ngIf="missingPerformanceData && !featureDisabled && digestStats"
      >
        <h4 class="dash-cta__title">
          <i
            class="glyphicon glyphicon--valign-baseline glyphicon-ab-gauge"
          ></i>
          Performance
        </h4>
        <p>
          This project has not received any performance data. Please follow the
          instructions on the Performance Dashboard to ensure we receive the
          data needed for performance trends.
        </p>
        <div class="dash-cta__image">
          <img
            src="{{ appEnv.cdnUrl }}/{{
              appEnv.assetsPath
            }}/images/performance-graph.svg"
            alt=""
          />
        </div>
        <p>
          <a class="btn btn--success" uiSref="project-performance">
            Install Performance Monitoring
          </a>
        </p>
      </div>

      <div class="ab-trend" *ngIf="!missingPerformanceData">
        <h4 class="ab-trend__title">Requests</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.performance.request_count_trend"
          [neutralTrend]="true"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.performance.request_count.current | numberToHuman }}
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs
            {{ digestStats.performance.request_count.previous | numberToHuman }}
            during the previous week
          </p>
        </div>
        <h4 class="ab-trend__title title-small">Rate</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.performance.request_rate_trend"
          [neutralTrend]="true"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.performance.request_rate.current | rateFormat }}/min
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs
            {{ digestStats.performance.request_rate.previous | rateFormat }}/min
            during the previous week
          </p>
        </div>
      </div>

      <div class="ab-trend" *ngIf="!missingPerformanceData">
        <h4 class="ab-trend__title">Response time</h4>
        <h4 class="ab-trend__title title-small">50th percentile</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.performance.p50_trend"
          [neutralTrend]="false"
          [increasePositive]="false"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.performance.p50.current.toFixed(2) }}ms
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs {{ digestStats.performance.p50.previous.toFixed(2) }}ms during
            the previous week
          </p>
        </div>
        <h4 class="ab-trend__title title-small">95th percentile</h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.performance.p95_trend"
          [neutralTrend]="false"
          [increasePositive]="false"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.performance.p95.current.toFixed(2) }}ms
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs {{ digestStats.performance.p95.previous.toFixed(2) }}ms during
            the previous week
          </p>
        </div>
      </div>

      <div class="ab-trend" *ngIf="!missingPerformanceData">
        <h4 class="ab-trend__title">
          Error rate
          <div
            class="ab-inline-tooltip"
            ngbTooltip="Error occurrences per request"
            container="body"
          >
            <span class="glyphicon glyphicon-question-circle glyphicon--blue">
            </span>
          </div>
        </h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.performance.error_rate_trend"
          [neutralTrend]="false"
          [increasePositive]="false"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.performance.error_rate.current | rateFormat }}%
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs {{ digestStats.performance.error_rate.previous | rateFormat }}%
            during the previous week
          </p>
        </div>
      </div>

      <ng-template #apdexTooltip>
        <ab-apdex-tooltip-text></ab-apdex-tooltip-text>
      </ng-template>

      <div class="ab-trend" *ngIf="!missingPerformanceData">
        <h4 class="ab-trend__title">
          Apdex score
          <div
            class="ab-inline-tooltip"
            [ngbTooltip]="apdexTooltip"
            container="body"
            closeDelay="2000"
          >
            <span class="glyphicon glyphicon-question-circle glyphicon--blue">
            </span>
          </div>
        </h4>
        <ab-digest-stats-trend
          *ngIf="digestStats; else spinnerInline"
          class="ab-trend__trend"
          [trend]="digestStats.performance.apdex_score_trend"
          [neutralTrend]="false"
          [increasePositive]="true"
        >
        </ab-digest-stats-trend>
        <div class="ab-trend__detail">
          <p class="ab-trend__number" *ngIf="digestStats">
            {{ digestStats.performance.apdex_score.current.toFixed(2) }}
            (<a href="/projects/{{ project.id }}/edit" target="_self"
              >T={{ digestStats.performance.apdex_threshold.current }}</a
            >)
          </p>
          <p class="ab-trend__small" *ngIf="digestStats">
            vs
            {{ digestStats.performance.apdex_score.previous.toFixed(2) }} (T={{
              digestStats.performance.apdex_threshold.previous
            }}) during the previous week
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
